<template>
  <div class="intros">
    <ImageBlock
      v-if="featuredImage"
      class="intros__image"
      :content="featuredImage" />
    <div
      v-if="intro"
      class="intros__text grid-wrap">
      <p
        class="intros__text-p grid--sm-100 grid--lg-50 bold"
        v-html="intro"></p>
    </div>
    <div
      v-if="introQuote"
      class="intros__quote">
      <Quote :content="introQuote" />
    </div>
    <Video
      v-if="introVideo"
      class="intros__video"
      :content="introVideo" />
  </div>
</template>

<script>
import ImageBlock from '@/components/sections/types/ImageBlock'
import Quote from '@/components/sections/types/Quote'
import Video from '@/components/Video'

export default {
  name: 'Intros',
  components: {
    ImageBlock,
    Quote,
    Video
  },
  props: {
    featuredImage: {
      type: Object,
      default: null
    },
    intro: {
      type: String,
      default: null
    },
    introQuote: {
      type: String,
      default: null
    },
    introVideo: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
  .intros {
    > * {
      @include section;
    }
    .intros__image,
    .intros__video {
      padding-top: rem(20)
    }
    .intros__text {
      display: flex;

      @include desktop {
        p {
          margin-left: auto;
        }
      }
    }
  }
</style>
